<template>
  <div class="gc-page-project-wrap">
    <van-nav-bar :border="false"
                 title="项目参与审核"
                 left-arrow
                 @click-left="$router.back()"
    />
    <div class="page-project-wrap box">
      <div class="item">
        <span>项目名称：</span>{{ detailInfo.Item.Name }}
      </div>
      <div class="item">
        <span>项目编号：</span>{{ detailInfo.Item.Sysno }}
      </div>
      <div class="item">
        <span>项目金额：</span>¥{{ detailInfo.ProALLMoney }}
      </div>
      <div class="item">
        <span>项目时间：</span>{{ detailInfo.PlanStartDate.substr(0, 10) }}至{{ detailInfo.PlanOverTime.substr(0, 10) }}
      </div>
      <div class="item">
        <span>项目标签：</span>{{ detailInfo.ProSource ? '外部' : '内部' }}
      </div>
      <div class="item" style="display:block">
        <span>项目描述</span>
        <div class="tip">
          {{ detailInfo.ProRemark }}
        </div>
      </div>
    </div>
    <div v-if="detailInfo.AcItemLst && detailInfo.AcItemLst[0].UserWorkNo" class="page-member-wrap box">
      <div class="title">
        <span class="s1">出资人员</span>
        <span class="s2">权重</span>
        <span class="s2">金额</span>
      </div>
      <div class="info-wrap">
        <div class="info-item" v-for="(item,index) in detailInfo.AcItemLst" :key="index">
          <span class="s1">{{ item.UserDepName }}-{{ item.Item.Name }}</span>
          <span class="s2">{{ item.WorkRight }}%</span>
          <span class="s2">{{ item.WorkWeight }}</span>
        </div>
      </div>
    </div>
    <div v-if="detailInfo.AcItemLst && !detailInfo.AcItemLst[0].UserWorkNo" class="page-dep-wrap box">
      <div class="item">
        <span>出资人员：</span>
        <div class="info">
          {{ detailInfo.AcItemLst[0].UserDepName }}
        </div>
      </div>
    </div>
    <div class="page-dep-wrap box">
      <div class="item">
        <span>验收人员：</span>
        {{ detailInfo.AcceptanceName }}
      </div>
      <div class="item">
        <span>参与部门：</span>
        <div class="info">
          <p v-for="(item2,index) in detailInfo.DepType" :key="index">{{ item2 }}</p>
        </div>
      </div>
      <!-- <div class="item">
          <span>出资人员：</span>
          <div class="info">
              <p>技术中心-总监-陈军</p>
              <p>技术中心-总监-陈军</p>
              <p>技术中心-总监-陈军</p>
          </div>
      </div> -->
    </div>
    <!-- <div v-if="detailInfo.ItemLst" class="page-member-wrap box">
        <div class="title">
            <span class="s1">已参与人员</span>
            <span class="s2">比重</span>
            <span class="s2">进度</span>
        </div>
        <div class="info-wrap">
            <div  class="info-item" v-for="(item,index) in detailInfo.ItemLst" :key="index">
                <span class="s1">{{item.UserDepName}}-{{item.Item.Name}}</span>
                <span class="s2">{{item.WorkWeight}}%</span>
                <span class="s2">{{item.ProStatus}}%</span>
            </div>
        </div>
    </div> -->
    <div class="page-member-wrap box">
      <div class="title">
        <span class="s1">参与部门姓名</span>
        <span class="s2">权重</span>
        <span class="s2">操作</span>
      </div>
      <div class="info-wrap">
        <div class="info-item" v-for="(item,index) in joinList" :key="index">
          <span class="s1">{{ item.UserDepName }}-{{ item.Item.Name }}</span>
          <span class="s2">
                        <div class="input-wrap">
                            <!-- <input type="number" :disabled="item.JoinStatus!=0" v-model="item.WorkWeight" class="input" value="0" @keyup="item.WorkWeight>100?item.WorkWeight=100:''"><i>%</i>     -->
                            <div class="input"
                                 @click="item.JoinStatus==0?showWeightPicker(index):''">{{ item.WorkWeight ? item.WorkWeight : '请选择' }}<i>%</i></div>
                        </div>
                    </span>
          <span class="s2">
                        <div class="btn btn2" v-if="item.JoinStatus == 0" @click="handleJoin(1,item.Item.Sysno,item.WorkWeight,index)">通过</div>
                        <div class="btn btn1" v-if="item.JoinStatus == 0" @click="handleJoin(5,item.Item.Sysno,item.WorkWeight,index)">驳回</div>
                        <div class="btn dis" v-if="item.JoinStatus == 1">已通过</div>
                        <div class="btn dis" v-if="item.JoinStatus == 5">已驳回</div>
                    </span>
        </div>
        <div class="info-item">
          <span class="s1">合计</span>
          <span class="s2">{{ allWeight }}%</span>
          <span class="s2"></span>
        </div>
      </div>
    </div>


    <!-- <div class="review-btn">
        <div class="btn btn1" @click="handleReview(0)">全部驳回</div>
        <div class="btn btn2" @click="handleReview(1)">全部通过</div>
    </div> -->

    <!-- 选择权重 -->
    <van-popup v-model="showWeight" position="bottom">
      <van-picker
        ref="weight"
        show-toolbar
        :columns="columnsWeight"
        @confirm="onConfirmWeight"
        @cancel="showWeight=false"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      detailInfo: {
        Item: {
          Name: ''
        },
      },
      joinList: [],
      // 权重
      showWeight: false,
      weightActiveIndex: 0,
      columnsWeight: [],

      // allWeight: 0
    }
  },
  mounted() {
    this.WebGetDealProjectInfoEx();
    this.WebGetBUserProjectItemExLst()
    // 初始化权重
    for (let i = 1; i <= 100; i++) {
      this.columnsWeight.push(i)
    }
  },
  // watch:{
  //     joinList:{
  //         handler(){
  //             let all = 0
  //             if(this.joinList){
  //                 for(let item of this.joinList){
  //                     all += Number(item.WorkWeight)
  //                 }
  //             }
  //             this.allWeight = all
  //         },
  //         deep: true
  //     }
  // },
  computed: {
    allWeight() {
      // console.log('allWeight');
      let all = 0
      if (this.joinList) {
        for (let item of this.joinList) {
          all += Number(item.WorkWeight)
        }
      }
      return all
    }
  },
  methods: {
    // 项目详情
    WebGetDealProjectInfoEx() {
      let data = {
        DepSysno: this.$route.params.sysno,
        UserId: localStorage.getItem('UserSysno')
      }
      this.$baseajax.normalJsonp(this.$base.baseProject + '/WebGetDealProjectInfoEx', data, res => {
        console.log(res);
        res = res.WebGetDealProjectInfoExResult
        if (res.ResponseCode == 1) {
          this.detailInfo = res.Item;
        }
      }, err => {
      })
    },
    // 获取项目参与详情
    WebGetBUserProjectItemExLst() {
      let data = {
        DepSysno: this.$route.params.sysno
      }
      this.$baseajax.normalJsonp(this.$base.baseProject + '/WebGetBUserProjectItemExLst', data, res => {
        console.log(res);
        res = res.WebGetBUserProjectItemExLstResult
        if (res.ResponseCode == 1) {
          this.joinList = res.ItemLst
        }
      }, err => {
      })
    },
    // 审核参与项目
    WebUpdateAddJoinStageItemStatus(status, usersysno, level, index) {
      let data = {
        Item: {
          ProSysno: this.$route.params.sysno,//项目编号
          UserSysno: usersysno, //参与人员编号
          StageStatus: status, //0参与 1通过 2驳回
          StageLevel: level, //权重
        }
      }
      this.$baseajax.sliceRequest(this.$base.baseProject + '/WebUpdateAddJoinStageItemStatus', data, res => {
        console.log(res);
        if (res.ResponseCode == 1) {
          this.joinList[index].JoinStatus = status
        }
      }, err => {
      })
    },
    handleJoin(status, usersysno, level, index) {
      if (status == 1) {
        if (!level) {
          this.$toast('参与权重不能为0')
          return
        }
      }
      this.$dialog.confirm({
        title: '提示',
        message: '是否确认此操作？',
        confirmButtonColor: '#D32F2F'
      }).then(() => {
        this.WebUpdateAddJoinStageItemStatus(status, usersysno, level, index)
      }).catch(() => {
      })

    },
    //选择权重
    showWeightPicker(index) {
      this.weightActiveIndex = index
      this.showWeight = true
      let v = this.joinList[this.weightActiveIndex].WorkWeight ? this.joinList[this.weightActiveIndex].WorkWeight : 1
      this.$nextTick(() => {
        this.$refs.weight.setValues([v]);
      })

    },
    onConfirmWeight(v) {
      var all = 0
      if (this.joinList) {
        for (let i in this.joinList) {
          if (i != this.weightActiveIndex) {
            all += Number(this.joinList[i].WorkWeight)
          }
        }
      }
      if (all + v > 100) {
        this.$toast('权重和不能大于100%')
        return
      }

      this.joinList[this.weightActiveIndex].WorkWeight = v
      // this.$set(this.joinList[this.weightActiveIndex],'WorkWeight',v)

      this.showWeight = false
    },
    // 全部通过，驳回
    handleReview(status) {
      let data = {}
      this.$baseajax.sliceRequest(this.$base.baseProject + '/aaa', data, res => {
        console.log(res);
        if (res.ResponseCode == 1) {

        }
      }, err => {
      })
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/views/project/ReviewJoin.vue